/*
 * @Author: cn1994
 * @Date: 2024-12-26 15:45:06
 * @LastEditors: cn1994
 * @LastEditTime: 2024-12-26 16:13:17
//  * @Description: file content
 */
// v-click-tracking.js
import dayjs from "dayjs";
import { useUserStore } from '@/stores/user'
import {useInstStore} from "@/stores/inst";

export default {
  bind(el, binding, vnode) {
    const handleClick = (e) => {
      console.log('handleClick binding', binding.value)
      
      let clickNodeClassName = e.target.className
      // 点击tabs的空白地方拦截
      if (clickNodeClassName.includes('el-tabs') && !clickNodeClassName.includes('el-tabs__item')) {
        return
      }
      
      const userStore = useUserStore()
      const instStore = useInstStore()
      const defaultParams = {
        bm_admin_role: userStore.adminRole,
        bm_role: userStore.role,
        bm_inst_code: userStore.instCode,
        bm_inst_id: userStore.instId,
        bm_subject: instStore.subject,
        bm_click_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        bm_user_name: userStore.userName,
        bm_user_id: userStore.userId,
      }
      // 设置config
      const uniqueUserId = `${userStore.serverId}_${userStore.userId}`
      window.collectEvent('config', {user_unique_id: uniqueUserId});
      const pagePath = vnode.context.$route.fullPath; // 获取页面路径
      const pageTitle = vnode.context.$route.meta.title
      const content = e.target.innerText
      const clickData = {
        ...defaultParams,
        bm_page_path: pagePath,
        bm_page_title: (binding.value && binding.value.title) ? binding.value.title : pageTitle,
        bm_page_module: (binding.value && binding.value.module) ? binding.value.module : pageTitle,
        bm_click_content: (binding.value && binding.value.content) ? binding.value.content : content,
      };

      // 发送数据到埋点服务
      console.log('Sending tracking data:', clickData);
      // 这里可以调用一个函数发送数据，例如：
      
      window.collectEvent('bm_click', clickData);
    };

    el.addEventListener('click', handleClick);
    el._clickTrackingHandler = handleClick; // 保存引用以便后续卸载
  },
  unbind(el) {
    el.removeEventListener('click', el._clickTrackingHandler); // 清理事件监听
  },
};
